// extracted by mini-css-extract-plugin
module.exports = {"root":"marquee_root__bIdKM","list":"marquee_list__XbFpL","scroll-x":"marquee_scroll-x__5qNUT","icon":"marquee_icon__EI3N7"};